/**
 * Lessons — the study list, grouped General Knowledge → Air Brakes → Combination
 * as the design's `.lesson-card`s (with a green `.lc-status` when complete). A
 * `.learn-switch` toggles to Bite-Size Study. Ports renderLearn's list view;
 * lesson bodies open at /training/learn/:lessonId (LessonDetail). Emits the CA
 * CDL trainer design's exact classes (vendored training-design.css).
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { lessons, tests, TEST_KEYS, type TestKey } from '@/content/training';
import { useTrainingProgress } from '../TrainingProgressContext';
import { trainingPath } from '../trainingNav';
import { PageHeader } from './TrainingUI';
import { BiteSize } from './BiteSize';

export function Lessons() {
  const navigate = useNavigate();
  const progress = useTrainingProgress();
  const [mode, setMode] = useState<'lessons' | 'bites'>('lessons');

  return (
    <div className="mx-auto max-w-3xl">
      <div className="learn-head">
        <div>
          <PageHeader
            title="Lessons"
            sub="Everything the DMV can ask, distilled from the California Commercial Driver Handbook. Work top to bottom — General Knowledge first, then Air Brakes, then Combination Vehicles."
          />
        </div>
        <div className="learn-switch">
          {(['lessons', 'bites'] as const).map((m) => (
            <button key={m} onClick={() => setMode(m)} className={mode === m ? 'on' : undefined}>
              {m === 'lessons' ? 'Lessons' : 'Bite-size study'}
            </button>
          ))}
        </div>
      </div>

      {mode === 'bites' ? (
        <BiteSize />
      ) : (
        <div>
          {TEST_KEYS.map((g: TestKey) => (
            <section key={g}>
              <h3
                style={{
                  fontSize: 12.5,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '.05em',
                  color: 'var(--muted)',
                  margin: '20px 0 10px',
                }}
              >
                {tests[g].name}
              </h3>
              <div className="lesson-list">
                {lessons
                  .filter((l) => l.test === g)
                  .map((l) => {
                    const done = !!progress.lessonsDone[l.id];
                    return (
                      <button
                        key={l.id}
                        className={`lesson-card${done ? ' is-done' : ''}`}
                        onClick={() => navigate(`${trainingPath('learn')}/${l.id}`)}
                      >
                        <div className="lc-top">
                          <div className="lc-sec">Lesson {l.num}</div>
                          {done && (
                            <div className="lc-status">
                              <CheckCircle2 /> Completed
                            </div>
                          )}
                        </div>
                        <h4>{l.title}</h4>
                        <p>{l.blurb}</p>
                      </button>
                    );
                  })}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
